import React, { useState, useEffect } from "react";
import {
	Card,
	CardHeader,
	CardContent,
	Typography,
	Button,
	Box,
	Paper,
} from "@material-ui/core";
import { usePermissions } from "ra-core";
import { useShopifyUrl } from "~/hooks/shopify-url.tsx";
import { useTimezone } from "~/hooks/timezone.tsx";
import { Analytics } from "../analytics/index.tsx";
import { DateTime } from "luxon";

type DashboardProps = {
	siteTitle: string;
};

function TimezoneClock() {
	const [currentTime, setCurrentTime] = useState(DateTime.now());
	const timezone = useTimezone();

	useEffect(() => {
		const timer = setInterval(() => {
			setCurrentTime(DateTime.now().setZone(timezone));
		}, 1000);

		return () => clearInterval(timer);
	}, [timezone]);

	return (
		<Paper style={{ padding: "1rem", marginBottom: "1rem" }}>
			<Typography variant="h6" gutterBottom>
				Timezone: {timezone}
			</Typography>
			<Typography variant="h4">{currentTime.toFormat("HH:mm:ss")}</Typography>
			<Typography variant="subtitle1">
				{currentTime.toFormat("EEEE, MMMM d, yyyy")}
			</Typography>
		</Paper>
	);
}

function Dashboard({ siteTitle }: DashboardProps) {
	const { permissions } = usePermissions();
	const shopifyUrl = useShopifyUrl();
	const links = [
		{ href: "https://dashboard.stripe.com/", label: "Stripe Dashboard" },
		{ href: `${shopifyUrl}/admin`, label: "Shopify Admin" },
		{ href: "https://www.klaviyo.com/dashboard", label: "Klaviyo Admin" },
		{ href: "https://admin.mailchimp.com/", label: "Mailchimp Admin (Legacy)" },
	];

	return (
		<Box
			style={{
				display: "flex",
				flexDirection: "column",
				gap: "1rem",
				marginTop: "1rem",
			}}
		>
			<CardHeader title={`Brick.me ${siteTitle} admin system`} />
			<TimezoneClock />
			<Analytics />
			<Card>
				{permissions && permissions.includes("*") && (
					<CardContent>
						<Typography>See also:</Typography>

						{links.map((link) => (
							<Button
								key={link.href}
								variant="contained"
								color="secondary"
								href={link.href}
								target="_blank"
								rel="noreferrer noopener"
								style={{ marginRight: "1rem" }}
							>
								{link.label}
							</Button>
						))}
					</CardContent>
				)}
			</Card>
		</Box>
	);
}

export { Dashboard };
